var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNutritsiolog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 49.795,
    height: 49.795,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 6.38 6.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil1,.fil11,.fil2{fill:#8fc114;fill-rule:nonzero}.fil1,.fil11{fill:#9fd332}.fil11{fill:#aab9f2}.fil10,.fil12,.fil15{fill:#bbea49;fill-rule:nonzero}.fil10,.fil15{fill:#e80054}.fil10{fill:#e9efff}.fil13,.fil3,.fil5{fill:#ffb332;fill-rule:nonzero}.fil13,.fil5{fill:#ffc839}.fil5{fill:#ffdd40}"))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2792224311456"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.73 4.81c.24-.44.38-.94.38-1.48a3.05 3.05 0 1 0-6.1 0c0 .38.07.75.2 1.09l5.53.39z",
    style: {
      fill: "#2a428c",
      fillRule: "nonzero"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61 2.04c.03.04.05.1.03.15-.02.08 0 .17.06.23.03.04.06.09.08.14.05-.01.11-.01.17 0 .07.01.13.03.18.07.04-.04.08-.08.13-.11.07-.04.11-.11.12-.2 0-.05.03-.1.08-.13.06-.04.1-.1.12-.18a.242.242 0 0 0-.14-.27.11.11 0 0 1-.06-.1.262.262 0 0 0-.22-.28.259.259 0 0 0-.29.19c-.01.04-.05.08-.09.08-.11.01-.2.1-.22.21-.01.07.01.15.05.2z",
    className: "fil1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43 1.72a.11.11 0 0 1-.06-.1.262.262 0 0 0-.22-.28.253.253 0 0 0-.21.06c.06.05.09.13.09.22 0 .04.02.08.06.1a.256.256 0 0 1 .02.45c-.05.03-.07.08-.08.13-.01.08-.05.16-.12.2-.02.01-.04.02-.05.04.03 0 .06 0 .08.01.07.01.13.03.18.07.04-.04.08-.08.13-.11.07-.04.11-.11.12-.2 0-.05.03-.1.08-.13.06-.04.1-.1.12-.18a.242.242 0 0 0-.14-.27z",
    className: "fil2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95 2.54c-.24-.04-.47.1-.52.33-.28 1.19-.33 2.39-.33 2.98 0 .11.15.15.22.06.59-.85.85-2.14 1.02-2.83.06-.25-.12-.5-.38-.54z",
    className: "fil3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.95 2.54c-.02 0-.05-.01-.07-.01 0 0 .09.19.04.47-.06.28-.1.68-.1.68s-.08.54 0 .74c.01.04.06.09.12.15.18-.56.3-1.11.39-1.48.06-.25-.12-.5-.38-.54z",
    style: {
      fill: "#ff9100",
      fillRule: "nonzero"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m4.67 3.16-.32-.05c-.05-.01-.09-.06-.08-.11.01-.05.06-.09.11-.08l.32.05c.05.01.09.06.08.11-.01.05-.06.09-.11.08z",
    className: "fil5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.06.64h-1v.33c0 .07-.06.13-.13.13H1.79c-.07 0-.13-.06-.13-.13V.64h-1a.48.48 0 0 0-.48.48V4.4c.09.23.2.45.34.65l1.3 1.08c.37.16.79.25 1.22.25.25 0 .49-.03.71-.08.09-.07.41-.32.78-.59V1.12a.48.48 0 0 0-.48-.48z",
    style: {
      fill: "#73c3f9",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.53 6.34c.05-.09.06-.17-.04-.21-.39-.16-.34-.69-.34-.69V2.38c-.13-.16 0-.3 0-.3l-.01-.19c-.12-.19.05-.28.05-.28l.03-.26c-.04-.16.16-.23.16-.23l-.02-.02h-.55c-.07 0-.13-.06-.13-.13V.64h-1a.48.48 0 0 0-.48.48V4.4c.09.23.2.45.34.65l1.3 1.08c.22.1.45.17.7.21z",
    style: {
      fill: "#1e9ef4",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21 5.98V1.12c0-.08-.06-.14-.14-.14h-.99c0 .07-.06.12-.13.12H1.81c-.07 0-.13-.05-.13-.12H1.5c-.05.04-.16.15-.16.41v.26c0 .07-.06.13-.13.13H.9c-.2 0-.33.12-.37.17v3.11c.32.47.77.85 1.3 1.08h2.23c.08 0 .14-.06.14-.14z",
    style: {
      fill: "#d3dcfb",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.49 6.13c-.39-.16-.34-.69-.34-.69V2.38c-.13-.16 0-.3 0-.3l-.01-.19c-.12-.19.05-.28.05-.28l.03-.26c-.04-.16.16-.23.16-.23l-.02-.02h-.55c-.07 0-.13-.05-.13-.12H1.5c-.05.04-.16.15-.16.41v.26c0 .07-.06.13-.13.13H.9c-.2 0-.33.12-.37.17v3.11c.32.47.77.85 1.3 1.08h.66z",
    style: {
      fill: "#bec8f7",
      fillRule: "nonzero"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M.66 1.67c-.08.08-.13.19-.13.3 0 0 .12-.18.37-.18h.31c.08 0 .14-.07.14-.14v-.26c0-.33.18-.41.18-.41-.11 0-.22.05-.3.13l-.57.57z",
    className: "fil10"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65 2.45h-.46c-.06 0-.11.05-.11.11v.46c0 .06.05.11.11.11h.46c.06 0 .11-.05.11-.11v-.46c0-.06-.05-.11-.11-.11z",
    className: "fil1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71 2.07h-.68a.09.09 0 0 1-.09-.09c0-.05.04-.09.09-.09h.68c.05 0 .09.04.09.09 0 .05-.04.09-.09.09zM3.66 2.56H2.15a.09.09 0 0 1-.09-.09c0-.05.04-.09.09-.09h1.51c.05 0 .09.04.09.09 0 .05-.04.09-.09.09zM3.66 2.89H2.15a.09.09 0 0 1-.09-.09c0-.05.04-.09.09-.09h1.51c.05 0 .09.04.09.09 0 .05-.04.09-.09.09zM2.84 3.22h-.68a.09.09 0 0 1-.09-.09c0-.05.04-.09.09-.09h.68c.05 0 .09.04.09.09 0 .05-.04.09-.09.09zM3.66 3.67H2.15a.09.09 0 0 1-.09-.09c0-.05.04-.09.09-.09h1.51c.05 0 .09.04.09.09 0 .05-.04.09-.09.09zM3.66 4H2.15a.09.09 0 0 1-.09-.09c0-.05.04-.09.09-.09h1.51c.05 0 .09.04.09.09 0 .05-.04.09-.09.09zM2.84 4.33h-.68a.09.09 0 0 1-.09-.09c0-.05.04-.09.09-.09h.68c.05 0 .09.04.09.09 0 .05-.04.09-.09.09zM3.66 4.78H2.15a.09.09 0 0 1-.09-.09c0-.05.04-.09.09-.09h1.51c.05 0 .09.04.09.09 0 .05-.04.09-.09.09zM3.66 5.1H2.15a.09.09 0 0 1-.09-.09c0-.05.04-.09.09-.09h1.51c.05 0 .09.04.09.09 0 .05-.04.09-.09.09zM2.84 5.43h-.68a.09.09 0 0 1-.09-.09c0-.05.04-.09.09-.09h.68c.05 0 .09.04.09.09 0 .05-.04.09-.09.09z",
    className: "fil11"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41 2.17c.03.04.05.1.03.15-.02.08 0 .17.06.23.03.04.06.09.08.14.05-.01.11-.01.17 0 .07.01.13.03.18.07.04-.04.08-.08.13-.11.07-.04.11-.11.12-.2 0-.05.03-.1.08-.13.06-.04.1-.1.12-.18a.242.242 0 0 0-.14-.27.11.11 0 0 1-.06-.1.262.262 0 0 0-.22-.28.259.259 0 0 0-.29.19c-.01.04-.04.08-.09.08-.11.01-.2.1-.22.21-.01.07.01.15.05.2z",
    className: "fil12"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.78 2.61a.31.31 0 0 1-.06-.23c.01-.05 0-.11-.03-.15-.04-.05-.07-.13-.05-.2.02-.11.11-.2.22-.21.04-.01.08-.04.09-.08.02-.08.08-.15.15-.18a.259.259 0 0 0-.44.11c-.01.04-.04.08-.09.08-.11.01-.2.1-.22.21-.01.07.01.15.05.2.03.04.05.1.03.15-.02.08 0 .17.06.23.03.04.06.09.08.14.05-.01.11-.01.17 0 .03.01.06.01.09.02-.02-.03-.04-.07-.06-.1z",
    className: "fil1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m5.25 3.6-.3-.05c-.05-.01-.09-.06-.08-.11.01-.05.06-.09.11-.08l.3.05c.05.01.09.06.08.11-.01.05-.06.09-.11.08z",
    className: "fil5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64 4.88c.23-.62.4-1.26.5-1.67.06-.25-.12-.5-.38-.54-.24-.04-.47.1-.52.33-.21.89-.29 1.79-.32 2.43.3-.23.58-.44.72-.55z",
    className: "fil13"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23 2.99c-.21.89-.29 1.79-.32 2.43.3-.23.58-.44.72-.55 0-.01.01-.02.01-.03-.41-.39-.13-1.27-.06-1.64.07-.4.43-.42.43-.42a.482.482 0 0 0-.26-.12c-.24-.04-.47.1-.52.33z",
    className: "fil3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49 3.29h-.01l-.32-.05c-.05-.01-.09-.06-.08-.11.01-.05.06-.09.11-.08l.32.05c.05.01.09.06.08.11-.01.05-.05.08-.09.08zM6.07 3.73h-.01l-.3-.05c-.05-.01-.09-.06-.08-.11.01-.05.06-.09.11-.08l.3.05c.05.01.09.06.08.11-.01.05-.05.08-.09.08zM5.54 3.98h-.01l-.22-.04c-.05-.01-.09-.06-.08-.11.01-.05.06-.09.11-.08l.22.04c.05.01.09.06.08.11-.01.05-.05.08-.09.08zM5.84 4.47h-.01l-.37-.06c-.05-.01-.09-.06-.08-.11.01-.05.06-.09.11-.08l.37.06c.05.01.09.06.08.11-.01.05-.05.08-.09.08z",
    className: "fil5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.73 4.79c-.19-.33-.55-.55-.96-.55-.04 0-.09 0-.13.01a.67.67 0 0 1-.2 0c-.04-.01-.09-.01-.13-.01-.61 0-1.11.5-1.11 1.11 0 .4.22.76.54.95.86-.2 1.58-.76 1.99-1.51z",
    style: {
      fill: "#ff4155",
      fillRule: "nonzero"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53 4.4v-.14c-.03 0-.06 0-.08-.01-.04-.01-.09-.01-.13-.01-.61 0-1.11.5-1.11 1.11 0 .4.22.76.54.95.21-.05.41-.12.61-.21-.2-.2-.32-.47-.32-.77 0-.38.2-.72.49-.92z",
    className: "fil15"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55 4.48a.09.09 0 0 1-.09-.09c0-.44.23-.69.23-.7.03-.04.09-.04.13-.01.04.03.04.09.01.13 0 0-.19.21-.19.58 0 .05-.04.09-.09.09z",
    className: "fil1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01 4.02c-.05-.02-.08-.07-.06-.12.02-.05.07-.08.12-.06.25.08.48.03.52 0 .04-.03.1-.01.13.03s.01.1-.03.13c-.12.07-.41.11-.68.02zM4.29 3.4c-.03.01-.06.04-.06.08-.01.21.2.37.4.3.03-.01.06-.04.06-.08.01-.21-.2-.37-.4-.3z",
    className: "fil12"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67.65a.09.09 0 0 1-.09-.09V.4c0-.12-.09-.21-.21-.21s-.21.09-.21.21v.16c0 .05-.04.09-.09.09a.09.09 0 0 1-.09-.09V.4c0-.22.18-.4.4-.4.22 0 .4.18.4.4v.16c0 .05-.04.09-.09.09z",
    className: "fil3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94.51H1.8c-.08 0-.15.07-.15.15v.31c0 .08.07.15.15.15h1.14c.08 0 .15-.07.15-.15V.66c0-.08-.07-.15-.15-.15z",
    className: "fil13"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8.51c-.08 0-.15.07-.15.15v.31c0 .08.07.15.15.15h.57c-.3-.3 0-.61 0-.61H1.8z",
    className: "fil3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37 1.67c-.13 0-.25-.08-.3-.19-.01-.02-.03-.03-.04-.03-.15 0-.28-.13-.28-.28v-.08c0-.05.04-.09.09-.09.05 0 .09.04.09.09v.08c0 .05.04.09.09.09.09 0 .18.06.22.14.02.05.07.08.13.08.05 0 .1-.03.13-.08a.23.23 0 0 1 .22-.14c.05 0 .09-.04.09-.09v-.08c0-.05.04-.09.09-.09.05 0 .09.04.09.09v.08c0 .15-.13.28-.28.28-.02 0-.04.01-.04.03-.05.12-.17.19-.3.19z",
    className: "fil5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1.38 2.45h-.19c-.06 0-.11.05-.11.11v.46c0 .06.05.11.11.11h.29c-.06-.06-.01-.16-.01-.16l-.15-.28c-.08-.15.07-.24.07-.24z",
    className: "fil2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 3c-.02 0-.05-.01-.07-.03l-.15-.15c-.04-.04-.04-.1 0-.13.04-.04.1-.04.13 0l.08.08.2-.2c.04-.04.1-.04.13 0 .04.04.04.1 0 .13l-.27.27a.09.09 0 0 1-.07.03z",
    className: "fil10"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65 3.56h-.46c-.06 0-.11.05-.11.11v.46c0 .06.05.11.11.11h.46c.06 0 .11-.05.11-.11v-.46c0-.06-.05-.11-.11-.11z",
    className: "fil1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1.38 3.56h-.19c-.06 0-.11.05-.11.11v.46c0 .06.05.11.11.11h.29c-.06-.06-.01-.16-.01-.16l-.15-.28c-.08-.15.07-.24.07-.24z",
    className: "fil2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 4.11c-.02 0-.05-.01-.07-.03l-.15-.15c-.04-.04-.04-.1 0-.13.04-.04.1-.04.13 0l.08.08.2-.2c.04-.04.1-.04.13 0 .04.04.04.1 0 .13l-.27.27a.09.09 0 0 1-.07.03z",
    className: "fil10"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65 4.67h-.46c-.06 0-.11.05-.11.11v.46c0 .06.05.11.11.11h.46c.06 0 .11-.05.11-.11v-.46c0-.06-.05-.11-.11-.11z",
    className: "fil1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1.38 4.67h-.19c-.06 0-.11.05-.11.11v.46c0 .06.05.11.11.11h.29c-.06-.06-.01-.16-.01-.16l-.15-.28c-.08-.15.07-.24.07-.24z",
    className: "fil2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 5.22c-.02 0-.05-.01-.07-.03l-.15-.15c-.04-.04-.04-.1 0-.13.04-.04.1-.04.13 0l.08.08.2-.2c.04-.04.1-.04.13 0 .04.04.04.1 0 .13l-.27.27a.09.09 0 0 1-.07.03z",
    className: "fil10"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4 3.68c0-.09.08-.17.17-.17.03 0 .06.01.08.02-.07-.12-.22-.19-.36-.13-.03.01-.06.04-.06.08-.01.14.08.25.19.3a.161.161 0 0 1-.03-.09z",
    className: "fil1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.13,
    cy: 4.88,
    r: 0.13,
    className: "fil15"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.55,
    cy: 5.19,
    r: 0.13,
    className: "fil15"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.21,
    cy: 5.9,
    r: 0.13,
    className: "fil15"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.03,
    cy: 5.19,
    r: 0.23,
    className: "fil15"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 5.6,
    r: 0.23,
    className: "fil15"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutritsiolog);
export default __webpack_public_path__ + "static/media/nutritsiolog.bb9a015dd273b61ff5ebc5259d67c85f.svg";
export { ForwardRef as ReactComponent };